import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  submit: i18n.t('contract_versions.flows.request_promote.footer.submit'),
})
